import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '../store';
Vue.use(VueRouter);

const routes = [
  { path: '*', redirect: '/' },
  {
    path: '/',
    name: 'books',
    component: () => import('../views/Books.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  { path: '/books', redirect: '/' },
  {
    path: '/add',
    name: 'add',
    component: () => import('../components/Modal.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/scanner',
    name: 'scanner',
    component: () => import('../views/Scanner.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/book/:id',
    component: () => import('../views/Book.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/user/:id',
    component: () => import('../views/User.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/profil',
    name: 'profil',
    component: () => import('../views/Profil.vue'),
    meta: {
      requiresLogin: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/Signup.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/ForgotPassword.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.isLoggedIn;
  if (to.matched.some(record => record.meta.requiresLogin) && !isLoggedIn) {
    next('/login');
    console.log('Login wäre nötig, ist: ', isLoggedIn);
  } else {
    next();
    console.log('Kein Login nötig, ist: ', isLoggedIn);
  }
});

export default router;
